import { Locale } from '@ps-smart-cp/ppfw-client';

const reLeaseAndContractExpiredClassConfig = {
  contractRelease: new Map([[Locale.ja, '契約を再リースする']]),
  contractExpired: new Map([[Locale.ja, '契約を満了する']]),
};

export { reLeaseAndContractExpiredClassConfig };
